import React from 'react';
import PdfPage from "../../PdfPage";
import {formatDate} from "../../../services/UtilityService";
import Images from "../../Images";

const CoverPage = ({ details }) => {
    const completedAt = React.useMemo(() => {
        return formatDate(details?.current_team?.completed, 'MMMM DD, YYYY');
    }, [details]);

    return (
        <PdfPage sectionClassName={'CoverPage'}>
            <div className='CoverPage__layout'>
                <div className='CoverPage__banner'>
                    <span className='CoverPage__bannerTitle'>Team Assessment Report</span>
                </div>

                <div className='CoverPage__body'>
                    <div className='CoverPage__logo'>
                        <img src={Images.report.logo5d} alt='5 Dysfunctions of a Team' />
                    </div>

                    <div className='CoverPage__teamInfo'>
                        {details.current_team.team_type === 'individual' && (
                            <span className='CoverPage__teamInfoName'>Individual Assessment</span>
                        )}
                        <span className='CoverPage__teamInfoName'>{details.current_team.name}</span>
                        {details.current_team.company_name && (
                            <span>{details.current_team.company_name}</span>
                        )}
                        <span>{`Completed: ${completedAt}`}</span>
                    </div>
                </div>

                <div className='CoverPage__footer'>
                    <div className='CoverPage__poweredBy'>
                        <img src={Images.report.poweredByTg} alt='Powered by The Table Group' />
                    </div>
                </div>

                <div className='CoverPage__pyramid'>
                    <img src={Images.report.pyramidWhiteFill} alt='' />
                </div>
            </div>
        </PdfPage>
    );
};

export default CoverPage;
